import React from 'react';
import { GlobalStyles } from '../../styles/styledComponents/globalStyles';
import PageInformationContainer from '../PageInformation/PageInformationContainer';
import PictureImage from '../utils/Picture';
import { withContent } from '../../hoc/withContext';
import { IContext } from '../../types';
import {
    BackgroundImageContainer,
    PageInformationCenter
} from './PageContainerStyle';
import { PageContainerRelative } from '../PageInformation/PageInformationStyle';

const PageContainer = ({ context }: IContext) => {
    return (
        <PageContainerRelative>
            {/*Global styles defenition*/}
            <GlobalStyles />
            <BackgroundImageContainer>
                <PictureImage
                    images={[
                        {
                            imageName: 'ubisoft-plus_hero_desktop',
                            minWidth: 1720
                        },
                        {
                            imageName: 'ubisoft-plus_hero_mobile',
                            minWidth: 900
                        }
                    ]}
                    extension={'jpg'}
                    className={['']}
                    altText={context.mozaicAltText}
                />
            </BackgroundImageContainer>
                <PageInformationCenter>
                    <PageInformationContainer />
                </PageInformationCenter>
        </PageContainerRelative>
    );
};

export default withContent(PageContainer);
